import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Database, Users } from 'lucide-react';
import { useAdminContext } from './adminContext';
import { AdminCrmModule } from '../../components/admin/AdminCrmModule';
import { AdminParticipantsApplications } from '../../components/AdminParticipantsApplications';

export function AdminCrmPage() {
  const { adminKey } = useAdminContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab');
  const initialTab = rawTab === 'participants' ? 'participants' : 'deals';
  const [crmTab, setCrmTab] = useState<'deals' | 'participants'>(initialTab);

  const handleTabChange = (tab: 'deals' | 'participants') => {
    setCrmTab(tab);
    setSearchParams(tab === 'deals' ? {} : { tab });
  };

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      {/* Sub-tab Navigation */}
      <div className="flex items-center gap-2 border-b border-slate-200 pb-2">
        <button
          type="button"
          onClick={() => handleTabChange('deals')}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold transition-all cursor-pointer ${
            crmTab === 'deals'
              ? 'bg-[#0A3D27] text-white shadow-xs'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Database className="w-4 h-4" />
          <span>B2B Deals &amp; Pipeline</span>
        </button>

        <button
          type="button"
          onClick={() => handleTabChange('participants')}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold transition-all cursor-pointer ${
            crmTab === 'participants'
              ? 'bg-[#0A3D27] text-white shadow-xs'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Users className="w-4 h-4" />
          <span>Participants &amp; Applications</span>
        </button>
      </div>

      {crmTab === 'deals' && <AdminCrmModule adminKey={adminKey} />}
      {crmTab === 'participants' && <AdminParticipantsApplications adminKey={adminKey} />}
    </div>
  );
}

export default AdminCrmPage;

